import React from "react";

import HomePage from "./views";

const Component = () => <HomePage />;

export default Component;
